import React, { useState } from "react";
import { Typography } from "antd";
import { MasterConfigs } from "../../../interfaces/entity";
import './index.scss';
import MasterComponent from "../../../components/Forms";

const IntialAdjustments = () => {
    const config: MasterConfigs = {
        title: 'Leave Categories',
        modalTitle: () => 'Leave Category',
        api: () => '/leave-category',
        combo: [],
        isActionTab: true,
        getColumns: () => [
            {
                title: 'Category Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Category Code',
                dataIndex: 'categoryCode',
                key: 'categoryCode',
            },
            {
                title: 'Paid Leave',
                dataIndex: 'isPaidLeave',
                key: 'isPaidLeave',
                render: (text) => text ? 'Paid' : 'Un Paid'
            }
        ],
        getFormColumns: () => [
            {
                label: 'Category Name',
                name: 'name',
                type: 'text',
                rules: [{ required: true, message: 'Please enter category name' }]
            },
            {
                label: 'Category Code',
                name: 'categoryCode',
                type: 'text',
                rules: [{ required: true, message: 'Please enter category code' }]
            },
            {
                label: 'Paid Leave',
                name: 'isPaidLeave',
                type: 'select',
                rules: [{ required: true, message: 'Please select leave type' }],
                children: [{ name: 'Paid', value: true }, { name: 'Un Paid', value: false }]
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                span: 24,
            }
        ],
        actions: [{ actionType: 'Add', name: 'Add Leave Category' }]
    }

    return <MasterComponent config={config} />
};

export default IntialAdjustments;